const MxToolTipStyles = (theme) => {
  return {
    tripTooltip: {
      width: 330,
        minWidth: 330,
          maxWidth: 330,
    }, 
    rotate90: {
      transform: [{ rotate: '90deg' }]
    }
  }
}
export default MxToolTipStyles;